export default class NPCEvent {
    constructor(type, npcContent) {
        this.type = type;
        this.npcContent = npcContent;
    }
}

NPCEvent.NPC_ADDED = "NPCEvent.NPC_ADDED";